var exports = {
  "O3": "xcc377c0b--4630f4--underground",
  "dl": "xcc377c0b--4630f4--underground-station",
  "or": "xcc377c0b--4630f4--underground-icon",
  "UI": "xcc377c0b--4630f4--underground-distance",
};

module.exports = exports;
